module.exports = "https://portperrypedals.ca/_res/img/grandview.f458db2.png";